import { createAsyncThunk } from "@reduxjs/toolkit";
import {   GetAllPreferences, register, changePassword } from "../../../fakebackend_helper";
import { apiError, apiErrorChange, getGoalSuccess, registerUserFailed, registerUserSuccessful, reset_register_flag } from "./reducer";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { 
  GetAllGoals as GetAllGoalsApi,
 } from "../../../fakebackend_helper";
 
 
// export const registerUser = (user, navigate) => async (dispatch) => {
//     try {
//       let response;
//   if (process.env.REACT_APP_API_URL) {
   
//         response = register(user);
//         var data = await response;

    
//         if (data.status === "SUCCESS") {
//           navigate("/otp");
//           dispatch(registerUserSuccessful(data.data));
         

//         } else {
//           dispatch(apiError(data));
//         }
//       }
//     } catch (error) {
//       dispatch(apiError(error.response.data));
//     }
//   };

  export const registerUser = (user, navigate) => async (dispatch) => {
    try {
        const response = await register(user);
        
        if (response.status === "SUCCESS") {
            navigate("/otp");
            dispatch(registerUserSuccessful(response.data));
        } else {
            dispatch(apiError(response));
        }
    } catch (error) {
        dispatch(apiError(error.response?.data || error.message));
    }
};
  export const resetRegisterFlag = () => async (dispatch) => {
    try {
      const response = dispatch(reset_register_flag());
      return response;
    } catch (error) {
      dispatch(apiError(error));
    }
  };

  export const GetAllGoalsServices1 = () => async (dispatch) => {
    try {
      const response = dispatch(GetAllGoalsApi());
      var data = await response;
    
      if (data.data.status === "SUCCESS") {
        console.log("data.data");
        console.log(data.data.data);
        dispatch(getGoalSuccess(data.data.data));
      } else {
        dispatch(apiError(data.data.data));
      }
    } catch (error) {
      // dispatch(apiError(error));
    }
  }

  // 1. Créer une requête asynchrone (GET) avec createAsyncThunk
/* export const GetAllGoalsServices =  createAsyncThunk(
  'goals/fetchGoals',
  async () => {
    try {
      const response = await GetAllGoalsApi();
      // var data = await response;
      return response.data;
    } catch (error) {
      return error;
    }

  }
); */


export const GetAllGoalsServices = createAsyncThunk(
  'goals/fetchGoals',
  async (_, { rejectWithValue }) => {
    try {
      const response = await GetAllGoalsApi();
      console.log('GOALS API RESPONSE:', response);
      return response;
    } catch (error) {
      // Renvoie l'erreur avec rejectWithValue pour une meilleure gestion
      return rejectWithValue(error.response || 'Erreur lors du chargement des objectifs');
    }
  }
);

export const GetAllPreferencesServices = createAsyncThunk(
  'goals/fetchPreferences',
  async (_, { rejectWithValue }) => {
    try {
      const response = await GetAllPreferences();
      return response.data;
    } catch (error) {
      // Renvoie l'erreur avec rejectWithValue pour une meilleure gestion
      return rejectWithValue(error.response?.data || 'Erreur lors du chargement des objectifs');
    }
  }
);
const tokenget = sessionStorage.getItem("authUser"); 
console.log("Valeur de sessionStorage:", tokenget); // Ajout du log

let token = null;
if (tokenget) {
  try {
    const parsedData = JSON.parse(tokenget); 
    token = parsedData?.data?.data?.token || null;
    console.log("Token récupéré:", token); // Vérifier que le token est bien extrait
  } catch (error) {
    console.error("Erreur lors du parsing du token:", error);
  }
}

// Async thunk pour récupérer les goals

export const useChangePassword = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleChangePassword = async (values, resetForm) => {
    setLoading(true);
    setError(null);

    try {
      await changePassword(values);
      alert("Mot de passe modifié avec succès !");
      resetForm();
      navigate("/login");
    } catch (error) {
      setError("Erreur lors du changement de mot de passe. Veuillez réessayer.");
      console.error("Erreur API :", error);
    } finally {
      setLoading(false);
    }
  };

  return { handleChangePassword, loading, error };
};